package com.rajen.angrejidictionary.pages

import androidx.compose.runtime.Composable
import com.rajen.angrejidictionary.components.layouts.PageLayoutData
import com.rajen.angrejidictionary.components.widgets.ContactForm
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*

@InitRoute
fun initContact(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(
        title = "Contact",
        description = "Contact Angreji Dictionary for suggestions, corrections and feedback."
    ))
}

@Page("/contact")
@Layout(".components.layouts.PageLayout")
@Composable
fun ContactPage() {

    // ❌ REMOVE THIS LINE: val viewModel = remember { ContactViewModel() }

    Box(
        Modifier.fillMaxWidth(),
        contentAlignment = Alignment.Center
    ) {
        Column(
            Modifier.fillMaxWidth().maxWidth(900.px).padding(leftRight = 1.cssRem),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                text = "CONTACT US",
                modifier = Modifier
                    .fontSize(clamp(1.8.cssRem, 5.vw, 2.5.cssRem))
                    .fontWeight(FontWeight.Bold)
                    .color(Color.rgb(0xD3, 0x35, 0x3E))
                    .textAlign(TextAlign.Center)
            )
            SpanText(
                text = "We'd love to hear from you",
                modifier = Modifier
                    .margin(top = 0.5.cssRem)
                    .fontSize(1.cssRem)
                    .color(Color.rgb(0xB6, 0x9B, 0x8C))
                    .textAlign(TextAlign.Center)
            )
            Image(
                src = "/divider.png", alt = "Divider",
                modifier = Modifier.width(220.px).margin(topBottom = 1.5.cssRem)
            )
            Column(
                Modifier.fillMaxWidth()
                    .backgroundColor(Color.rgb(0xFF, 0xF7, 0xF1))
                    .borderRadius(28.px).padding(2.cssRem)
                    .boxShadow(offsetY = 10.px, blurRadius = 30.px, color = Color.rgba(0, 0, 0, 0.06f)),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(1.cssRem)
            ) {
                SpanText(
                    text = "Have a question, suggestion, correction, or feedback? Send us a message and we'll get back to you as soon as possible.",
                    modifier = Modifier.fontSize(1.cssRem).lineHeight(1.8).color(Color.rgb(0x21, 0x00, 0x00))
                )
                ContactForm()
            }
        }
    }
}